import { render, staticRenderFns } from "./VTableData.vue?vue&type=template&id=cb12bd5e&"
import script from "./VTableData.vue?vue&type=script&lang=js&"
export * from "./VTableData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports